var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 97,
    viewBox: "0 0 76 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.348 49.0546V49.0558V75.9217C54.348 76.7209 54.0748 77.3815 53.502 77.9553C52.9301 78.5282 52.2706 78.8011 51.4707 78.8002H51.4695H24.6036C23.8044 78.8002 23.1447 78.527 22.5725 77.9548C22.0003 77.3826 21.7262 76.7221 21.7251 75.9211V49.0558C21.7251 48.2571 21.9985 47.5976 22.5719 47.0252C23.1461 46.452 23.8065 46.1784 24.6042 46.1773H51.4695C52.2682 46.1773 52.9287 46.4507 53.5026 47.0246C54.0765 47.5985 54.349 48.2579 54.348 49.0546ZM55.3075 49.0558V75.9217C55.3075 76.9771 54.932 77.881 54.1811 78.6332C53.4301 79.3855 52.5263 79.761 51.4695 79.7597H24.6036C23.5482 79.7597 22.645 79.3842 21.894 78.6332C21.143 77.8823 20.7669 76.9784 20.7656 75.9217L55.3075 49.0558ZM23.6441 75.9217V76.8812H24.6036H51.4695H52.429V75.9217V49.0558V48.0963H51.4695H24.6036H23.6441V49.0558V75.9217ZM42.3543 64.0879L47.6315 71.1242H37.0771L37.3649 70.7404L42.3543 64.0879ZM35.8297 70.7404L36.1176 71.1242H28.4416L32.2796 66.0069L35.8297 70.7404Z",
    fill: "black",
    stroke: "#292D32",
    strokeWidth: 1.91899
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8994 3V3C45.3183 3 47.6381 3.96134 49.348 5.67235L70.2932 26.6315C71.7599 28.0992 72.5838 30.0892 72.5838 32.1641V32.1641M42.8994 3H13.095C7.7958 3 3.5 7.29582 3.5 12.595V83.5978C3.5 88.8969 7.79582 93.1927 13.095 93.1927H62.9888C68.288 93.1927 72.5838 88.8969 72.5838 83.5978V32.1641M42.8994 3V22.5691C42.8994 27.8683 47.1952 32.1641 52.4943 32.1641H72.5838",
    stroke: "#292D32",
    strokeWidth: 5.75698
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageIcon);
export default __webpack_public_path__ + "static/media/image-icon.cb006436646d344202a463c38af6f24b.svg";
export { ForwardRef as ReactComponent };